<template>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2442.282205059925!2d0.8204520769989171!3d52.256420255710424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d9b3744edfc741%3A0x52361532179bdb92!2sEco%20Sweep!5e0!3m2!1sen!2suk!4v1737024174664!5m2!1sen!2suk"
    width="100%"
    :height="height"
    style="border:0;"
    allowfullscreen=""
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '450'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/GoogleMapsEmbed.vue